import styled from 'styled-components';


export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--bg-panel);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  color: var(--text-primary);
  border-radius: 6px;
  padding: 0.33rem .53rem;
  font-size: .92rem;
  cursor: pointer;
  transition: background 0.18s, box-shadow 0.18s, color 0.18s, border 0.18s;
  font-weight: 500;
  &:hover {
    background: var(--bg-hover);
    color: var(--brand-blue);
    border-color: var(--brand-blue);
    box-shadow: 0 4px 16px rgba(39,145,210,0.08);
  }
`;

export const FileIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--text-primary);
  min-width: 0;
`;

export const FileName = styled.span`
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;

export const DateCell = styled.div`
  color: var(--text-primary);
  font-size: 0.73rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
`;

export const Badge = styled.span`
  padding: 0.22rem 0.44rem;
  border-radius: 5px;
  font-size: 0.64rem;
  font-weight: 600;
  text-transform: capitalize;
  display: inline-block;
  background: ${props => props.status ? `var(--status-${props.status})` : 'var(--bg-panel-sub)'};
  color: #333 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
`;

export const UserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`;

export const UserAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--brand-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 0.73rem;
  flex-shrink: 0;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

export const UserName = styled.span`
  font-weight: 500;
  color: var(--text-primary);
  font-size: 0.73rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserEmail = styled.span`
  color: var(--text-muted);
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`; 